/*
 * Personal Digital Spaces LLC ("COMPANY") CONFIDENTIAL
 * Unpublished Copyright (c) 2026 Personal Digital Spaces LLC, All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains the property of COMPANY. The intellectual and technical concepts contained
 * herein are proprietary to COMPANY and may be covered by U.S. and Foreign Patents, patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material is strictly forbidden unless prior written permission is obtained
 * from COMPANY.  Access to the source code contained herein is hereby forbidden to anyone except current COMPANY employees, managers, contractors or partners who have executed
 * Confidentiality and Non-disclosure agreements explicitly covering such access.
 *
 * The copyright notice above does not evidence any actual or intended publication or disclosure  of  this source code, which includes
 * information that is confidential and/or proprietary, and is a trade secret, of  COMPANY.   ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC  PERFORMANCE,
 * OR PUBLIC DISPLAY OF OR THROUGH USE  OF THIS  SOURCE CODE  WITHOUT  THE EXPRESS WRITTEN CONSENT OF COMPANY IS STRICTLY PROHIBITED, AND IN VIOLATION OF APPLICABLE
 * LAWS AND INTERNATIONAL TREATIES.  THE RECEIPT OR POSSESSION OF  THIS SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY OR IMPLY ANY RIGHTS
 * TO REPRODUCE, DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING THAT IT  MAY DESCRIBE, IN WHOLE OR IN PART.
 */
export const getErrorContent = (state) => {
  const { code, message, requestId } = state ?? {}

  const states = {
    ORGANIZATION_REQUIRED: {
      title: 'Organization required',
      message: message ?? 'You must belong to an organization to continue.'
    },
    USER_NOT_AUTHENTICATED: {
      title: 'Authentication required',
      message: message ?? 'You need to sign in again.'
    },
    TOKEN_EXPIRED: {
      title: 'Session expired',
      message: message ?? 'Your session expired. Please sign in again.'
    },
    UNAUTHORIZED: {
      title: 'Unauthorized',
      message: message ?? 'You are not authorized to perform this action.'
    },
    NOT_FOUND: {
      title: 'Not found',
      message: message ?? 'The requested resource was not found.'
    },
    DATABASE_RECORD_NOT_FOUND: {
      title: 'Not found',
      message: message ?? 'The requested record was not found.'
    },
    DATABASE_CONFLICT: {
      title: 'Conflict',
      message: message ?? 'A conflict occurred while processing your request.'
    },
    VALIDATION_ERROR: {
      title: 'Validation error',
      message: message ?? 'Please review the submitted data.'
    },
    INTERNAL_SERVER_ERROR: {
      title: 'Something went wrong',
      message: message ?? 'Something went wrong. Please try again later.'
    }
  }

  const fallbackMessage = message ?? 'Something went wrong. Please try again later.'

  const content = states[code] ?? {
    title: formatTitleFromCode(code) ?? 'Something went wrong',
    message: fallbackMessage
  }

  return {
    ...content,
    requestId
  }
}

const formatTitleFromCode = (code) => {
  if (!code) return null

  if (code.endsWith('_FAILED')) {
    return 'Request failed'
  }

  return code
    .toLowerCase()
    .split('_')
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
    .join(' ')
}
